export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  evaluation: {},
  filters: {
    keyword: "",
    advanced: {
      cycle: null,
      sections: [],
      thematicAreas: [],
      types: [],
      status: [],
      branch: null,
      projects: [],
      regDates: [],
      startDates: [],
      endDates: [],
    },
  },
});
